import { urlAPI } from 'src/config';
import { get, patch } from '../../api/api';
import { IRespostaFuncao } from 'src/integracoes/modelos/funcoes';
import { IVersaoPbi } from '../modelos/IDefinicoesPbi';

export const obtemVersoesPbi = async (): Promise<IRespostaFuncao<IVersaoPbi[]>> => {
  return await get<IRespostaFuncao<IVersaoPbi[]>>(`${urlAPI}/definicoes-pbi/obtem-versoes-pbi`);
};

export const atualizarStatusVersaoPbi = async (versao: string, statusVersao: string): Promise<IRespostaFuncao<any>> => {
  return await patch<IRespostaFuncao<any>>(`${urlAPI}/definicoes-pbi/atualiza-status-versao`, { versao, statusVersao });
};
